import styles from './Footer.module.scss';

const Footer = (props) => {
  const { color } = props;
  let classWrap = `${styles.wrap}`;
  if (color !== undefined && styles[`wrap_${color}`] !== undefined) {
    classWrap += ` ${styles[`wrap_${color}`]}`;
  }

  return (
    <>
      <footer className={classWrap}>
        <div className="container">
          <div className={styles.inner}>
            <a
              href="https://dreamjob.ru/employers/44650"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.stat}
            >
              <img
                data-id="wg-44650-1-1"
                width="170"
                height="114"
                title="Рейтинг работодателя на Dream Job"
                src={
                  'https://dreamjob.ru/uploads/widgets/wg-44650-1-1.svg?' +
                  ~~(Date.now() / 864e5)
                }
                alt="Р-Фарм отзывы сотрудников о работодателе на Dream Job"
              />
            </a>

            <div className={styles.icons}>
              <a
                href="http://vk.com/teamrpharm"
                target="_blank"
                rel="noreferrer"
                className={styles.social}
              >
                <svg
                  width="54"
                  height="54"
                  viewBox="0 0 54 54"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M27 54C41.9117 54 54 41.9117 54 27C54 12.0883 41.9117 0 27 0C12.0883 0 0 12.0883 0 27C0 41.9117 12.0883 54 27 54ZM12.4258 18.3833C12.6641 29.8232 18.384 36.6982 28.4123 36.6982H28.9808V30.1532C32.6658 30.5199 35.4521 33.2149 36.5705 36.6982H41.7773C40.3473 31.4916 36.5888 28.6132 34.2421 27.5133C36.5888 26.1566 39.8888 22.8566 40.6771 18.3833H35.947C34.9204 22.0133 31.8774 25.3133 28.9808 25.6249V18.3833H24.2506V31.0699C21.3173 30.3366 17.6141 26.7799 17.4491 18.3833H12.4258Z"
                    fill="white"
                  />
                </svg>
                <span>Присоединяйтесь к нам в соцсетях</span>
              </a>
            </div>
          </div>
          <div className={styles.links}>
            <a
              href="/doc/Согласие на обработку персональных данных.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Согласие на обработку персональных данных
            </a>
            <a
              href="/doc/Политика обработки файлов cookie.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Политика обработки файлов cookie
            </a>
            <a
              href="/doc/Политика обработки и обеспечения безопасности персональных данных.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Политика обработки и обеспечения безопасности персональных данных
            </a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
